export const BUILD_VERSION = '1793742701';
